function UnauthorizedCtrl($state, $stateParams) {
  const vm = this;

  vm.goBack = _goBack;

  // ----------------------- private helpers ----------------------- //

  function _goBack($event) {
    if ($event) $event.preventDefault();

    if ($stateParams.redirectState) {
      let params;

      if ($stateParams.redirectParams) {
        try {
          params = JSON.parse($stateParams.redirectParams);
        } catch (err) {
          console.log(err);
        }
      }

      $state.go($stateParams.redirectState, params);
    }
  }
}

UnauthorizedCtrl.$inject = ['$state', '$stateParams'];

export default UnauthorizedCtrl;



// WEBPACK FOOTER //
// ./src/components/unauthorized/unauthorizedCtrl.js